// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VModal from 'vue-js-modal'
import config from './configuration'
import i18n from './i18n/index'
import vuex from 'vuex'
import PortalVue from 'portal-vue'
import '@/mixins/helper'
import '@/mixins/componentHelper'
import '@/mixins/console'
import '@/mixins/export'
import { EventBus } from '@/router/bus'
import { accessTokenValid, refreshTokenValid } from '@/router/auth'
import { getRefreshToken, getAccessToken, setAccessToken } from '@/utils/cookie'
import { endpointRequireToken } from './utils/endpoints'
import Vuetify from 'vuetify'
import 'vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap4.scss'
import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueTabulator from 'vue-tabulator'
import moment from 'moment'
// import hub from './utils/hub'
import 'spectre.css/dist/spectre.css'
import 'spectre.css/dist/spectre-icons.css'
import 'spectre.css/dist/spectre-exp.css'
import 'simplemde/dist/simplemde.min.css'
import 'flatpickr/dist/flatpickr.min.css'
import '@/assets/css/materialdesignicons.min.css'
import 'vuetify/dist/vuetify.min.css'
import '@/assets/scss/app.scss'
import securityStore from './store/security-store'

Vue.prototype.moment = moment

// const AUTHORIZATION = 'Authorization'
// const REFRESH_TOKEN = 'Refresh_Token'

Vue.use(Vue2Dropzone)
Vue.use(Vuetify)
Vue.use(config)
Vue.use(vuex)
Vue.use(VModal)
Vue.use(VueTabulator)
Vue.use(PortalVue)
// Vue.use(hub)

Vue.config.productionTip = false
Vue.config.debug = true
Vue.http.options.root = Vue.$config.api_root

Vue.http.interceptors.push(function (request, next) {
  securityStore.dispatch('startSessionInterval')
  const isTokenRequired = Vue.http.headers.common.REFRESH_TOKEN !== 'IN_PROGRESS' && endpointRequireToken(request.url, request.method)
  Vue.http.headers.common['Content-Type'] = 'application/json'
  if (isTokenRequired) {
    Vue.http.headers.common.Authorization = 'Bearer ' + getAccessToken()
    if (!accessTokenValid()) {
      handleInvalidToken(request, next)
      return
    }
  }
  // continue to next interceptor
  next()
})

// #region functions

function handleInvalidToken (request, next) {
  const isProductionEnvironment = process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
  if (!isProductionEnvironment) { console.log('Access token expired - attempting to refresh') }
  if (!refreshTokenValid()) {
    if (!isProductionEnvironment) { console.log('Refresh token no longer valid') }
    router.push('/')
    emitRefreshTokenExpired()
    securityStore.dispatch('unsetIsAuth')
  } else {
    // REFRESH TOKEN
    next(() => {
      Vue.http.headers.common.REFRESH_TOKEN = 'IN_PROGRESS'
      const refreshTokenUrl = Vue.$apiConfig.loginRefresh
      Vue.http.headers.common.Authorization = 'Bearer ' + getRefreshToken()
      return Vue.http.get(refreshTokenUrl)
        .then(response => {
          if (!isProductionEnvironment) { console.log('Access token refreshed successfully') }
          setAccessToken(response.data.payload.accessToken)
          Vue.http.headers.common.Authorization = 'Bearer ' + response.data.payload.accessToken
          Vue.http.headers.common.REFRESH_TOKEN = 'DONE'
          request.headers.set('Authorization', 'Bearer ' + response.data.payload.accessToken)
          return Vue.http(request).then(data => {
            return data
          })
        }, error => {
          Vue.http.headers.common.REFRESH_TOKEN = 'DONE'
          if (!isProductionEnvironment) { console.log('Failed to obtain new access token after refresh: ' + error) }
          router.push('/')
          let errorMessage = ''
          if (error.status === 0) {
            errorMessage = i18n.t('apiStatusCodes.0')
          } else {
            errorMessage = i18n.t('errors.token.failedToRefreshToken')
          }
          this.notifyError(errorMessage)
        })
    })
  }
}

function emitRefreshTokenExpired () {
  EventBus.$emit('alert', {
    variant: 'error',
    message: i18n.t('errors.token.refreshTokenExpired'),
    errors: []
  })
}

// function emitFailedToGetRefreshToken (error) {
//   let errorMessage = ''
//   if (error.status === 0) {
//     errorMessage = i18n.t('apiGatewayStatusCodes.0')
//   } else {
//     errorMessage = i18n.t('errors.token.failedToRefreshToken')
//   }
//   EventBus.$emit('alert', {
//     variant: 'error',
//     message: errorMessage,
//     errors: []
//   })
// }

// #endregion

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify({
    theme: {
      dark: false,
      options: {
        customProperties: true
      },
      themes: {
        dark: {
          primary: '#779ecb',
          secondary: '#23333e',
          'secondary-light': '#3d4d58',
          accent: '#b06f6f',
          anchor: '#6d79a6',
          inactive: '#c8d5d9',
          success: '#4caf50',
          cards: '#23333e',
          toolbar: '#D3D7DA',
          'v-divider': '#404a53',
          'v-window': '#23333e',
          background: '#D3D7DA',
          divider: '#404a53',
          warning: '#FF8F00',
          caption: '#fff',
          subcaption: '#c0c0c0',
          border: '#dee2e6',
          header: '#162936',
          error: '#ff5252',
          pending: '#779ecb'
        },
        light: {
          primary: '#4B8D9C',
          secondary: '#23333e',
          'secondary-light': '#3d4d58',
          accent: '#b06f6f',
          segment: '#6d79a6',
          anchor: '#6d79a6',
          inactive: '#c8d5d9',
          success: '#64b39a',
          'success-light': '#e1f2ed',
          toolbar: '#f2f4f7',
          cards: '#f5f8fa',
          'v-window': '#fcfcfc',
          background: '#fcfcfc',
          divider: '#404a53',
          warning: '#FF8F00',
          caption: '#202020',
          'caption-light': '#f5f2ed',
          subcaption: '#2a2a2a',
          border: '#dcdfe4',
          header: '#162936',
          error: '#ff5252',
          pending: '#779ecb',
          'active-light': '#607D8B',
          highlight: '#CFD8DC'
        }
      }
    }
  }),
  render: h => h(App),
  router,
  components: { App },
  i18n,
  template: '<App/>'
}).$mount('#app')
